import { FormControl, FormGroup } from '@angular/forms';
import { ICalendarAddressFilter, IFormGroup } from '@shared-libs/interfaces';

export class CalendarAddressFilterFormFactory {
	public static create(): IFormGroup<ICalendarAddressFilter> {
		return new FormGroup({
			address: new FormControl(),
			coordinates: new FormControl(),
			zipcode: new FormControl(),
			range: new FormControl(5),
		}) as IFormGroup;
	}
}
